export const NotifySizeAvailability = {
    modalTitle: "uiText.notifyWhenAvailable.modalTitle",
    notifyButton: "uiText.notifyWhenAvailable.notifyButton",
    policyAgreement: "uiText.notifyWhenAvailable.policyAgreement",
    success: {
        title: "uiText.notifyWhenAvailable.success.title",
        message: "uiText.notifyWhenAvailable.success.message",
        messageWithProduct: "uiText.notifyWhenAvailable.success.messageWithProduct",
        closeButton: "uiText.notifyWhenAvailable.success.closeButton",
        closeText: "uiText.notifyWhenAvailable.success.closeText",
    },
} as const;
